export default "__VITE_ASSET__qsDhqjpb__"